import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from "@iconify/react/dist/iconify.js";
import './languageSelector.css';

const LanguageSelector = ({ darkMode }) => {
  const { t, i18n } = useTranslation();
  const currentLang = i18n.language;
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    localStorage.setItem('preferredLanguage', lng);
    setIsOpen(false);
  };

  // Cerrar el dropdown cuando se hace click fuera
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // Usar el idioma guardado en localStorage al cargar
  useEffect(() => {
    const savedLanguage = localStorage.getItem('preferredLanguage');
    if (savedLanguage) {
      i18n.changeLanguage(savedLanguage);
    }
  }, [i18n]);

  return (
    <div className={`cs_language_selector ${darkMode ? 'cs_dark' : ''}`} ref={dropdownRef}>
      <div className={`cs_dropdown ${isOpen ? 'show' : ''}`}>
        <button 
          className="cs_lang_btn"
          onClick={() => setIsOpen(!isOpen)}
        >
          <Icon 
            icon={currentLang === 'en' ? "flag:gb-4x3" : "flag:es-4x3"} 
            className="cs_lang_icon"
          />
          <span className="cs_lang_text">{currentLang.toUpperCase()}</span>
          <Icon 
            icon="material-symbols:keyboard-arrow-down-rounded" 
            className="cs_arrow_icon"
          />
        </button>
        {isOpen && (
          <div className="cs_lang_dropdown">
            <button 
              className="cs_lang_option"
              onClick={() => changeLanguage('en')}
            >
              <Icon icon="flag:gb-4x3" className="cs_lang_icon" />
              <span>{t('language.english')}</span>
            </button>
            <button 
              className="cs_lang_option"
              onClick={() => changeLanguage('es')}
            >
              <Icon icon="flag:es-4x3" className="cs_lang_icon" />
              <span>{t('language.spanish')}</span>
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default LanguageSelector;